import _ from 'underscore';

export function addMessageToFieldConfig(i18n, ...fieldLists) {
  _.each(fieldLists, (fieldList) => {
    _.each(fieldList, (field) => {
      field.message = field.message || i18n.getString(field.property); //eslint-disable-line
    });
  });
}
